import React from 'react';
import { Globe, Inbox, Trophy, Target } from 'lucide-react';

function HighlightCard({ icon: Icon, label, country, detail, color, testId }) {
  return (
    <div className="bg-white rounded-lg p-4 border border-saffron-100/50 shadow-card-lift" data-testid={testId}>
      <div className="w-8 h-8 rounded-lg flex items-center justify-center mb-2" style={{ backgroundColor: color + '15' }}>
        <Icon size={16} style={{ color }} />
      </div>
      <p className="font-display text-lg font-bold text-earth-dark truncate" data-testid={`${testId}-country`}>{country || '—'}</p>
      <p className="text-xs text-earth/70 font-sans font-medium">{label}</p>
      {detail && <p className="text-[11px] text-earth/60 font-sans mt-0.5" data-testid={`${testId}-detail`}>{detail}</p>}
    </div>
  );
}

export default function CountryHighlights({ data }) {
  const { most_inquiries: top, most_orders: orders, best_conversion: best } = data.highlights;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="country-highlights">
      <HighlightCard icon={Globe} label="Countries reached" country={String(data.total_countries)} detail={`${data.total_inquiries} inquiries · ${data.overall_conversion}% won`} color="#6B8E23" testId="highlight-countries" />
      <HighlightCard icon={Inbox} label="Most inquiries" country={top?.country} detail={top && `${top.inquiries} inquiries · ${top.share}% of all`} color="#D4870A" testId="highlight-most-inquiries" />
      <HighlightCard icon={Trophy} label="Most orders (Won)" country={orders?.country} detail={orders ? `${orders.won} won orders` : 'No won orders yet'} color="#10B981" testId="highlight-most-orders" />
      <HighlightCard icon={Target} label="Best conversion" country={best?.country} detail={best ? `${best.conversion}% of ${best.inquiries} inquiries won` : 'Needs 2+ inquiries with a win'} color="#C0392B" testId="highlight-best-conversion" />
    </div>
  );
}
